<template>
  <div
    class="page password-change pb-8">
    <p class="page__logo">
      <img
        src="@/assets/images/logo@2x.png">
    </p>
    <div class="page__form general-form pt-4 p-md-6">
      <div class="general-form__text">
        <template v-if="isCreatePassword">
          <p>パスワードの設定を行います。<br>パスワードを下記フォームに入力してください。</p>
        </template>
        <template v-else>
          <p>パスワードの再設定を行います。<br>新しいパスワードを下記フォームに入力してください。</p>
        </template>
      </div>
      <form>
        <validation-observer v-slot="{ passes }">
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="newPassword"
              class="col-form-label">
              <template v-if="isCreatePassword">パスワード</template>  
              <template v-else>新しいパスワード</template>  
            </label>
            <validation-provider
              ref="new_password1" 
              v-slot="v"
              name="パスワード"
              rules="password|required"
              vid="password-confirmation">
              <b-form-input
                id="newPassword"
                v-model="newPassword"
                type="password"
                placeholder="****" />
              <p
                v-for="message in v.errors"
                :key="message"
                class="text-primary">
                {{ message }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="confirmationPassword"
              class="col-form-label">
              <template v-if="isCreatePassword">パスワード（確認）</template>  
              <template v-else>新しいパスワード（確認）</template>    
            </label>
            <validation-provider
              ref="new_password2" 
              v-slot="v" 
              name="確認用パスワード"
              rules="required|confirmed:password-confirmation">
              <b-form-input
                id="confirmationPassword"
                v-model="confirmationPassword"
                type="password"
                placeholder="****" />
              <p
                v-for="message in v.errors"
                :key="message"
                class="text-primary">
                {{ message }}
              </p>
            </validation-provider>
            <p class="mt-2 pb-3">
              <b-form-invalid-feedback
                v-for="message in nonFieldErrors"
                :key="message"
                :state="false">
                {{ message }}
              </b-form-invalid-feedback>
            </p>
          </div>
          <div class="general-form__btn mt-5">
            <button
              type="button"
              class="btn btn-block btn-primary"
              @click="passes(onClickReset)">
              <template v-if="isCreatePassword">
                パスワードを設定する
              </template>
              <template v-else>
                パスワードを再設定する
              </template>
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newPassword: '',
      confirmationPassword: '',
      uid: '',
      token: '',
      nonFieldErrors: []
    }
  },
  computed: {
    /* 
    テナント管理者によるメンバー追加後、そのメンバーに送られてくるメール記載のURLから
    このページに遷移してくるケースかどうかを判断
     */
    isCreatePassword() {
      return this.$route.query.type === 'new'
    },
  },
  methods: {
    onClickReset() {
      if (this.$store.state.isLoading) return
      this.nonFieldErrors = []

      this.$store.commit('startLoading')
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const postBody = {
        new_password1: this.newPassword,
        new_password2: this.confirmationPassword,
        uid,
        token
      }
      this.$axios.post('/auth/password/reset/confirm/', postBody)
        .then(async () => {
          await this.$store.dispatch('auth/logout')
          this.$router.push('/auth/login')
          const successMessage = this.isCreatePassword ? 
            'パスワードの設定が完了しました。設定されたパスワードでログインください。' 
            : 'パスワードの変更が完了しました。新しいパスワードでログインしてください。'
          this.$store.commit('notify/set', {
            message: successMessage
          })
        }).catch(err => {
          if (!err.response || !err.response.data) {
            this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
            this.$router.push('/auth/login')
            return
          }
          if ('uid' in err.response.data || 'token' in err.response.data) {
            this.nonFieldErrors = this.isCreatePassword ? 
              ['パスワードの設定ができませんでした。お送りしたメールに記載のURLに正しくアクセスできているか、ご確認ください。']
              : ['パスワードの変更ができませんでした。お送りしたメールに記載のURLに正しくアクセスできているか、ご確認ください。']
            return
          }
          if (err.response.data.newPassword1) {
            this.$refs.new_password1.applyResult({
              errors: err.response.data.newPassword1,
              valid: false,
              failedRules: {}
            })
          }
          if (err.response.data.newPassword2){
            this.$refs.new_password2.applyResult({
              errors: err.response.data.newPassword2,
              valid: false,
              failedRules: {}
            })
          }
        }).finally(() => {
          this.$store.commit('finishLoading')
        })
    }
  }
}
</script>

<style lang="sass" scoped></style>
